module.exports = __webpack_public_path__ + "media/73.f4b7227e.mp3";